export default __webpack_public_path__ + "static/media/3d-glasses-1.569457a8.png";